import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Print Report")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  style: {"font-weight":"normal"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  style: {"height":"100px"}
}
const _hoisted_7 = {
  key: 1,
  style: {"height":"100px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_button, {
      type: "info",
      icon: "el-icon-arrow-left",
      onClick: _ctx.routeBack
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_el_button, {
      onClick: _ctx.printReport,
      type: "primary"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["onClick"]),
    (_ctx.fetchState === _ctx.FetchStates.FETCHED)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("h1", null, _toDisplayString(_ctx.crashFile?.title), 1),
          _createVNode("h3", null, [
            (_ctx.crashFile)
              ? (_openBlock(), _createBlock("span", _hoisted_4, " Created on " + _toDisplayString(_ctx.convertDateString(
            _ctx.crashFile?.date_created ?? '',
            _ctx.userPrefs?.timezone ?? 0,
          )), 1))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reports, (report) => {
            return (_openBlock(), _createBlock("div", null, [
              (report.fullReport != null)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(report.component), {
                      report: report.report,
                      records: report.records,
                      isPrinting: true,
                      fullReport: report.fullReport
                    }, null, 8, ["report", "records", "fullReport"]))
                  ]))
                : _withDirectives((_openBlock(), _createBlock("div", _hoisted_6, null, 512)), [
                    [_directive_loading, true]
                  ])
            ]))
          }), 256))
        ]))
      : _withDirectives((_openBlock(), _createBlock("div", _hoisted_7, null, 512)), [
          [_directive_loading, true]
        ])
  ], 64))
}